import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import { IsSentEnum } from '../models/isSent.enum';

interface GroupMessageSmsTabsProps {
  initialValue: number | undefined;
  callback: (activeTab: number, isSent: boolean | undefined) => void;
}

type Tab = {
  id: number;
  label: string;
};

const tabs: Tab[] = [
  {
    id: 0,
    label: t('groupMessage:overview.tabs.all'),
  },
  {
    id: 1,
    label: t('groupMessage:overview.tabs.sent'),
  },
  {
    id: 2,
    label: t('groupMessage:overview.tabs.notSent'),
  },
];

export const GroupMessageSmsTabs = (props: GroupMessageSmsTabsProps) => {
  const { initialValue, callback } = props;
  const [activeTab, setActiveTab] = useState<number>(initialValue || 0);
  const [, setIsSent] = useState<boolean | undefined>();

  const handleTab = (tabIndex: number) => {
    setActiveTab(tabIndex);
    let sent;
    switch (tabIndex) {
      case IsSentEnum.All:
        sent = undefined;
        break;
      case IsSentEnum.Sent:
        sent = true;
        break;
      case IsSentEnum.NotSent:
        sent = false;
        break;
      default:
        sent = undefined;
    }
    setIsSent(sent);
    return sent;
  };

  const onTabSelect = (event: React.SyntheticEvent, tabIndex: number) => {
    const tmpIsSent = handleTab(tabIndex);
    callback(tabIndex, tmpIsSent);
  };

  useEffect(() => {
    if (initialValue !== undefined) {
      handleTab(initialValue);
    }
  }, [initialValue]);

  return (
    <Tabs
      value={activeTab}
      textColor='primary'
      onChange={onTabSelect}
      sx={{
        '& button': {
          textTransform: 'none',
        },
      }}
    >
      {tabs.map((tab: Tab) => (
        <Tab label={tab.label} key={tab.id} />
      ))}
    </Tabs>
  );
};
